'use client';

import { AdminProfile } from '../../types';

interface AdminHeaderProps {
  profile: AdminProfile;
  onLogout: () => void;
  onGoToKiosk: () => void;
}

export default function AdminHeader({ profile, onLogout, onGoToKiosk }: AdminHeaderProps) {
  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              파레트 키오스크 관리자
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              {profile.companies?.name} | {profile.full_name} ({profile.role === 'super_admin' ? '최고 관리자' : '회사 관리자'})
            </p>
          </div>
          <div className="flex space-x-4">
            <button
              onClick={onGoToKiosk}
              className="px-4 py-2 text-gray-700 hover:text-gray-900"
            >
              키오스크
            </button>
            <button
              onClick={onLogout}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            >
              로그아웃
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
